import React from 'react';

import * as Sentry from '@sentry/react';
import { BrowserTracing } from '@sentry/tracing';
import { Provider } from 'react-redux';

import './index.css';
import 'semantic-ui-css/semantic.min.css';
import 'assets/fonts/fonts.css';

import store, { persistor } from './store/store';
import { PersistGate } from 'redux-persist/integration/react';

import ErrorBoundary from 'error-handling/ErrorBoundary';
import { AppConfig } from './Config';
import FallbackComponent from './error-handling/FallbackComponent';
import ApplicationRouting from './ApplicationRouting';

if (AppConfig.environment !== 'development') {
  const Sentr_DSN = AppConfig.sentryDSN;
  Sentry.init({
    dsn: `${Sentr_DSN}`,
    integrations: [new BrowserTracing()],
    tracesSampleRate: 0.1,
  });
}
function App() {
  return (
    <>
      <div data-testid="app-root" />
      <ErrorBoundary FallbackComponent={FallbackComponent}>
        <Provider store={store}>
          <PersistGate loading={null} persistor={persistor}>
            <ApplicationRouting />
          </PersistGate>
        </Provider>
      </ErrorBoundary>
    </>
  );
}

export default App;
